import { useContext } from "react";
import { ThemeAssetContext } from "./ThemeProvider.context";

export const useThemeAssets = () => {
  return useContext(ThemeAssetContext);
};
